export const prettyFrequency = (frequency: number, unit: string) => {
  if (frequency === 1) return unit.toLowerCase()
  return `${frequency} ${unit.toLowerCase()}s`
}
